const html = require('choo/html')
const logo = require('../images/logoyellow.png')

module.exports = function Logo() {
  return html`
    <div id="logo">
      <a href="https://makeymakey.com" target="_blank">
        <img src="${logo}" alt="Makey Makey Music Sampler" />
      </a>
    </div>
  `
}
